import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestformHomeComponent } from './requestform-home.component';
import { ZnRequestformModule } from "./pages/zn-requestform/zn-requestform.module";
import { RequestFormModule } from "../request-form/request-form.module";
import { RequestformHomeRoutingModule } from './requestform-home-routing.module';



@NgModule({
  declarations: [
    RequestformHomeComponent
  ],
  imports: [
    CommonModule,
    ZnRequestformModule,
    RequestFormModule,
    RequestformHomeRoutingModule
],
  exports:[
    RequestformHomeComponent
  ]
})
export class RequestformHomeModule { }
